module.exports = __webpack_public_path__ + "img/mm-landing-banner-v2.de5ffc93.png";